export enum FloorcareProviders {
  NORTH_WEST_APPLIANCE = 'north west appliance repairs ltd',
  JST = 'jst electronics ltd',
  ES = 'e&s services (dar) ltd',
  ES_SKYLINE = 'e&s services (dar) ltd skyline',
}

export const floorcareBannerMessage = {
  [FloorcareProviders.NORTH_WEST_APPLIANCE]: 'The repairer will call you to arrange a collection.',
  [FloorcareProviders.ES]: 'The repairer will call you to arrange a collection or send replacement parts.',
  [FloorcareProviders.ES_SKYLINE]: 'The repairer will call you to arrange a collection or send replacement parts.',
  [FloorcareProviders.JST]:
    'The repairer will call you to arrange a collection or send replacement parts. (Got a BT postcode? If your item needs collecting, please package it up first.)',
};
